/*
 *   File : text-input.js
 *   Author : https://evoqins.com
 *   Description : Text input component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';

//custom style
import style from "../../Style/Component/input.module.scss";

//Custom components
import { Icon } from '../Icon';

const CustomSearchInput = (props) => {

    const [isInputFocused, setIsInputFocused] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [searchValue, setSearchValue] = useState("");

    useEffect(()=>{
        console.log('pros.value', props.value)
        setSearchValue(props.value)
    },[props.value])

    // handle focus 
    const _handleFocus = () => {
        setIsInputFocused(true);
    };

    const _handleBlur = () => {
        setIsInputFocused(false);
    };

    //input handle change
    const _handleChange = (e) => {
        let value = e.target.value;
        props.handleChange(value);
    };

    // handle enter key press
    const keyPress = (e) => {
        if (e.keyCode === 13 && typeof props.onKeyPress === 'function') {
            props.onKeyPress();
        }
    };
    const _handleKeyDown = (e) => {
        // Prevent default behavior of up and down arrow keys
        if (e.keyCode === 38 || e.keyCode === 40) {
            e.preventDefault();
        }
        if (props.type === "number") {
            if (e.key === '0' && props.value === '') {
                e.preventDefault();
            }
        }
        if (e.key === '.' && props.not_decimal) {
            e.preventDefault();
        }

        if (e.key === 'Backspace' && e.target.value.length < 2 && props.value != "") {
            props.onSearchClear();
        }
    };


    return (
        <div className={props.wrapperClass} ref={props.ref} >
            {props.label &&
                <label className={`${props.labelStyle} d-flex e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom`}>
                    {props.label}
                    {props.required &&
                        <span className='e-text-carmine-pink'>*</span>
                    }
                </label>
            }

            <div className={`${style.e_search_input_wrapper} position-relative `}>
                <div className={` ${props.error && style.e_error_border} ${isInputFocused ? `${style.e_active} ` : `${props.inputType === 2 ? "e-border-0-5px-arsenic" : style.e_inactive} `} ${props.inputType === 2 ? "border-radius-8" : "border-radius-100"}`}>
                    <input id={props.id}
                        autocomplete="off"
                        ref={props.ref}
                        value={searchValue}
                        defaultValue={props.defaultValue}
                        maxLength={props.maxLength}
                        tabIndex={props.tabIndex}
                        type={props.type}
                        required={props.required}
                        readOnly={props.readOnly}
                        autoFocus={props.autoFocus}
                        placeholder={props.placeholder}
                        className={`${props.className} ${props.inputType === 2 ? `${style.e_input_basket} padding-15px-tb ps-5 ` : `${style.e_input} padding-10px-tb padding-40px-left`} e-primary-font  padding-58px-right border-0 border-radius-100 e-bg-white e-font-14 e-text-chinese-black e-font-weight-500 line-height-20px text-truncate`}
                        onWheel={() => document.activeElement.blur()}
                        onFocus={_handleFocus}
                        onBlur={_handleBlur}
                        onChange={_handleChange}
                        onKeyDown={(e) => {
                            keyPress(e);
                            _handleKeyDown(e);
                        }}
                        onClick={props.onClick} />
                </div>

                {props.inputType === 2 ?
                    <Icon icon='search-blue'
                        size="1.5rem"
                        className="d-flex position-absolute top-14px left-16px" />
                    :
                    <Icon icon='search'
                        size="1rem"
                        className={'top-12px left-16px d-flex position-absolute'} />
                }

                {
                    props.value.length !== 0 &&
                    <Icon icon='close'
                        size={16}
                        className={`${props.clearIcon ? props.clearIcon : "top-13px right-36px"} d-flex position-absolute cursor-pointer  `}
                        onClick={props.onClear} />
                }
                {
                    props.value.length !== 0 && props.inputType === 1 &&
                    <div className='e-bg-blue-violet cursor-pointer position-absolute top-0 end-0 px-2 h-100 border-radius-trbr-100 d-flex align-items-center justify-content-center '
                        onClick={props.onSearch} >
                        <Icon icon='back'
                            size="1rem"
                            color="#FFFFFF"
                            className={`d-flex e-rotate-180 ${style.e_search_icon}  transition`} />
                    </div>
                }

                {props.error &&
                    <p className={`${style.e_error_message} position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                        {props.error}
                    </p>
                }
            </div>
        </div >
    )
}

CustomSearchInput.defaultProps = {
    onKeyPress: () => { },
    handleChange: () => { },
    onSearchClear: () => { },
    className: null,
    error: "",
    value: "",
    inputType: 1,
    onSearch: () => { }
}

export default memo(CustomSearchInput);